export default __webpack_public_path__ + "static/media/fourimages.e93233ed.jpeg";